/**
* @Description 文件功能说明：修改密码弹窗
* @Author cc
* @Time 2021/5/14
**/

/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               :modal-append-to-body="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >

        <el-form :model="dialogRowForm" :rules="rules" ref="dialogRowForm" label-width="120px">
            <el-form-item v-if="false && !dialogForm.isEdit" label="人员类型：" prop="typeId" style="margin-bottom: 20px;">
              <el-select v-model="dialogRowForm.typeId" placeholder="请选择人员类型">
                <el-option v-for="(item, key) in userTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="人员组名：" prop="groupName" style="margin-bottom: 20px;">
                <el-input v-model="dialogRowForm.groupName" clearable />
            </el-form-item>
            <el-form-item class="btn-form-item-c">
                <el-button type="primary" @click="submitForm()"><i class="el-icon-success" /> {{dialogForm.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

/* JS */
<script>
    import ApiUser from '@/request/api-user'
    import {checkEmpty,validFormat,checkFormat} from '@/global/global-valid'

    export default {

      props: {
        // 用户组集合
        userTypes: Array,
      },
        /**
         * @Des 组件名
         * @Auth CC
         * @Date 2021/5/14
         */
        name: 'UserGroupDialog',
        /**
         * @Des 数据定义
         * @Auth CC
         * @Date 2021/5/14
         */
        data() {
            return{
                /**
                 * @Des 弹窗表单
                 * @Auth CC
                 * @Date 2021/5/14
                 */
                dialogForm: {
                    isEdit: true,
                    title: "人员组",
                    dialogFormVisible: false,
                    submitButton: '保存'
                },
                /**
                 * @Des 弹窗行值
                 * @Auth CC
                 * @Date 2021/5/14
                 */
                dialogRowForm: {
                    typeId: '',
                    groupId: '',
                    groupName: '',
                    submitLock: false
                },
                /**
                 * @Des 弹窗规则
                 * @Auth CC
                 * @Date 2021/5/14
                 */
                rules: {
                    typeId: [
                        { required: true, message: '请选择类型', trigger: 'blur' },
                    ],
                    groupName: [
                        { required: true, message: '请输入人员组名', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
	                            if (!checkFormat(value, validFormat.username_xm)) {
	                            	new callback(new Error("名称不合法。可包含：汉字、字母、数字、下划线等"));
	                            } else {
	                                callback()
	                            }
	                        },
	                        trigger: "blur"
                        }
                    ],
                },
            }
        },
        /**
	     * @Des 初始化页面加载完成后的处理
	     * @Auth CC
	     * @Date 2021/5/14
	     */
        created () {

        },
        /**
         * @Des 方法定义
         * @Auth CC
         * @Date 2021/5/14
         */
        methods:{
            /**
             * @Des 弹窗打开
             * @Auth CC
             * @Date 2021/5/14
             */
            openDialog(isEdit, data){
                // console.log(isEdit, data)
                this.dialogForm.isEdit = isEdit;
              this.dialogRowForm.typeId = '';
              if(isEdit){
                  this.dialogForm.title = '编辑人员组';
                  this.dialogRowForm.groupId = data.id;
                  this.dialogRowForm.groupName = data.name;
                }else{
                  this.dialogForm.title = '添加人员组';
                    this.dialogRowForm.groupId = '';
                    this.dialogRowForm.groupName = '';
                }
                this.dialogForm.dialogFormVisible = true;
            },
            /**
             * @Des 弹窗关闭
             * @Auth CC
             * @Date 2021/5/14
             */
            handleDialogClose(){
                this.reset()
            },
            /**
             * @Des 重置方法
             * @Auth CC
             * @Date 2021/5/14
             */
            reset(){
                this.cleanData(this.dialogRowForm);
                this.cleanValidate('dialogRowForm');
            },
            /**
             * @Des 提交方法
             * @Auth CC
             * @Date 2021/5/14
             */
            submitForm(){
                if(this.dialogRowForm.submitLock){
                    return;
                }
                // 表单验证
                this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;
                    this.dialogRowForm.submitLock = true;
                    let api = this.dialogForm.isEdit?ApiUser.updateUserGroupApi: ApiUser.addUserGroupApi;
                    // 提交人员组 交互
                    this.$request.postJsonRequest(api, {
                        // typeId: (this.dialogRowForm.typeId &&this.dialogRowForm.typeId != "")?this.dialogRowForm.typeId.replace("T",""):"",
                        groupId: this.dialogRowForm.groupId,
                        groupName: this.dialogRowForm.groupName,
                        // projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '人员组保存成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true,
                                duration: 2000,
                                onClose: (() => {})
                            });
                        	// 刷新页面
                            this.dialogForm.dialogFormVisible = false;
                            this.$emit("flushGroup", this.dialogRowForm.groupId, this.dialogRowForm.groupName);
                            this.dialogRowForm.submitLock = false;
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.dialogRowForm.submitLock = false;
                        }
                    }).catch(error => {
                    	this.dialogRowForm.submitLock = false;
                    	console.error((this.dialogForm.isEdit ? '编辑' : '新增') + '人员组异', api, error);
                    })
                })
            },
            /**
             * @Des 清除验证
             * @Auth CC
             * @Date 2021/5/14
             */
            cleanValidate(formName){
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清理数据
             * @Auth CC
             * @Date 2021/5/14
             */
            cleanData(form){
                this.$nextTick(function () {
                    // 重置数据
                    form = Object.assign({}, {
                    	typeId: '',
	                    typeName: '',
	                    groupId: '',
	                    groupName: '',
                    });
                });
            }

        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/User/UserGroupDialog.vue